import { getAlgoliaClient } from './algoliaClientFactory'

/**
 * Execute a Discover-page repository search.
 *
 * Centralises the Algolia client + initIndex + search pattern used by
 * DiscoverSubjectPage and DiscoverSeeAllPage. Swapping the discover search
 * engine requires changing only this function.
 *
 * @param {Object} params
 * @param {string} params.searchKey   Algolia search-only API key.
 * @param {string} params.indexName   Algolia index to query (e.g. 'repos_latest').
 * @param {string} params.filters     Algolia filter string.
 * @param {number} params.hitsPerPage Maximum number of hits to return.
 * @returns {Promise<Object[]>} Resolves with the array of hit objects.
 */
export function searchDiscoverRepos({
  searchKey, indexName, filters, hitsPerPage,
}) {
  const searchClient = getAlgoliaClient(
    process.env.REACT_APP_PLICKERS_ALGOLIA_APP_ID,
    searchKey,
  )
  return searchClient
    .initIndex(indexName)
    .search('', { hitsPerPage, filters })
    .then(({ hits }) => hits)
}
